import { useState } from 'react';
import AppLayout from '@/components/feature/AppLayout';
import { mockCases } from '@/mocks/cases';

export default function SupReportsPage() {
  const [reportGenerated, setReportGenerated] = useState(false);
  const [reportType, setReportType] = useState('lgu');

  return (
    <AppLayout title="Reports" breadcrumb={['Supervisor', 'Reports']}>
      <div className="space-y-6">
        <div className="bg-white rounded-xl border border-gray-100 p-6">
          <h3 className="font-semibold text-gray-800 mb-4">Generate Official Reports</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            {[
              { key: 'lgu', label: 'LGU / Mayor Report', desc: "Summary report for local government unit and mayor's office. Includes legal basis automatically.", icon: 'ri-government-line' },
              { key: 'dswd', label: 'DSWD Compliance Report', desc: 'Compliance report for DSWD regional office submission with legal references.', icon: 'ri-file-shield-line' },
              { key: 'monthly', label: 'Monthly Statistical Report', desc: 'Monthly case statistics, trend analysis, and barangay breakdown.', icon: 'ri-bar-chart-2-line' },
              { key: 'worker', label: 'Social Worker Performance', desc: 'Individual performance report per social worker with response/resolution times.', icon: 'ri-user-star-line' },
            ].map((r) => (
              <button key={r.key} onClick={() => setReportType(r.key)}
                className={`flex items-start gap-4 p-4 rounded-xl border-2 text-left cursor-pointer transition-all ${reportType === r.key ? 'border-teal-500 bg-teal-50' : 'border-gray-200 hover:border-gray-300'}`}>
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${reportType === r.key ? 'bg-teal-500' : 'bg-gray-100'}`}>
                  <i className={`${r.icon} ${reportType === r.key ? 'text-white' : 'text-gray-500'} text-lg`} />
                </div>
                <div>
                  <p className={`text-sm font-semibold ${reportType === r.key ? 'text-teal-700' : 'text-gray-800'}`}>{r.label}</p>
                  <p className="text-xs text-gray-500 mt-0.5">{r.desc}</p>
                </div>
              </button>
            ))}
          </div>
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div><label className="text-sm font-medium text-gray-700 mb-1.5 block">Date From</label><input type="date" defaultValue="2026-01-01" className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-teal-500" /></div>
            <div><label className="text-sm font-medium text-gray-700 mb-1.5 block">Date To</label><input type="date" defaultValue="2026-04-09" className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-teal-500" /></div>
          </div>
          <div className="flex gap-3">
            <button onClick={() => setReportGenerated(true)} className="bg-teal-500 text-white text-sm px-5 py-2.5 rounded-xl hover:bg-teal-600 cursor-pointer whitespace-nowrap flex items-center gap-2"><i className="ri-file-chart-line" />Generate Report</button>
            <button className="border border-gray-200 text-gray-700 text-sm px-4 py-2.5 rounded-xl hover:bg-gray-50 cursor-pointer whitespace-nowrap flex items-center gap-2"><i className="ri-file-excel-line" />Export Excel</button>
            <button className="border border-gray-200 text-gray-700 text-sm px-4 py-2.5 rounded-xl hover:bg-gray-50 cursor-pointer whitespace-nowrap flex items-center gap-2"><i className="ri-file-pdf-line" />Export PDF</button>
          </div>
        </div>

        {reportGenerated && (
          <div className="bg-white rounded-xl border border-teal-200 p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center"><i className="ri-file-chart-line text-teal-600 text-lg" /></div>
              <div>
                <p className="font-semibold text-gray-800">Report Generated Successfully</p>
                <p className="text-xs text-gray-400">Generated on 2026-04-09 · {reportType.toUpperCase()} Report · Legal basis auto-included</p>
              </div>
              <button onClick={() => setReportGenerated(false)} className="ml-auto text-gray-400 hover:text-gray-600 cursor-pointer"><i className="ri-close-line" /></button>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
              {[{ label: 'Total Cases', value: mockCases.length }, { label: 'Active', value: mockCases.filter((c) => c.status === 'active').length }, { label: 'Closed', value: mockCases.filter((c) => c.status === 'closed').length }, { label: 'Critical', value: mockCases.filter((c) => c.riskLevel === 'critical').length }].map((s) => (
                <div key={s.label} className="bg-gray-50 rounded-xl p-3 text-center border border-gray-100">
                  <p className="text-2xl font-bold text-gray-900">{s.value}</p>
                  <p className="text-xs text-gray-500">{s.label}</p>
                </div>
              ))}
            </div>
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 mb-4">
              <p className="text-xs text-amber-700 font-medium mb-1">Legal Basis Auto-Included:</p>
              <div className="flex gap-2 flex-wrap">
                {['RA 7610', 'RA 9344', 'RA 9262', 'DSWD AO-01-2019'].map((l) => <span key={l} className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">{l}</span>)}
              </div>
            </div>
            <div className="flex gap-3">
              <button className="bg-teal-500 text-white text-sm px-4 py-2 rounded-xl hover:bg-teal-600 cursor-pointer whitespace-nowrap flex items-center gap-2"><i className="ri-download-line" />Download PDF</button>
              <button className="border border-gray-200 text-gray-700 text-sm px-4 py-2 rounded-xl hover:bg-gray-50 cursor-pointer whitespace-nowrap flex items-center gap-2"><i className="ri-printer-line" />Print</button>
            </div>
          </div>
        )}
      </div>
    </AppLayout>
  );
}
